export const OPTIONAL_ENUM_PROP_NAMES: Readonly<
  Record<string, readonly string[]>
> = {
  Accordion: [
    'chevronSize',
    'contentPaddingX',
    'contentPaddingY',
    'density',
    'iconSize',
    'labelGap',
    'radius',
    'titleSize',
    'titleWeight',
    'triggerPaddingX',
    'triggerPaddingY',
    'triggerPosition',
    'type',
    'variant',
  ],
  AccordionItem: [
    'chevronSize',
    'contentPaddingX',
    'contentPaddingY',
    'density',
    'iconSize',
    'labelGap',
    'radius',
    'titleSize',
    'titleWeight',
    'triggerPaddingX',
    'triggerPaddingY',
    'triggerPosition',
    'variant',
  ],
  ArticleCard: ['border', 'hoverStyle', 'layout', 'size', 'variant'],
  ArticleHeroBanner: ['color'],
  ArticleLayout: ['border', 'hoverStyle'],
  ArticleRow: ['border', 'heroAlign', 'hover-style'],
  Avatar: ['size'],
  Badge: [
    'emphasis',
    'size',
    'size-lg',
    'size-md',
    'tone',
    'variant',
    'weight',
  ],
  TagLink: ['size', 'variant'],
  Bar: ['orientation', 'variant'],
  BarChart: [
    'colorScale',
    'divergingPalette',
    'mode',
    'orientation',
    'sequentialPalette',
    'sortBy',
    'tooltipMode',
    'xAxisInterval',
    'xAxisType',
  ],
  BentoBox: ['cellVariant', 'columns', 'gap'],
  BrandCard: ['variant'],
  Breadcrumb: ['color', 'linkUnderline', 'linkWeight', 'size'],
  Brow: ['align', 'color'],
  Button: [
    'hoverTreatment',
    'iconColor',
    'iconSize',
    'size',
    'underline',
    'variant',
    'width',
    'width-lg',
    'width-md',
  ],
  Callout: ['actionPosition', 'state', 'style'],
  Card: [
    'backgroundPosition',
    'backgroundRepeat',
    'backgroundSize',
    'border',
    'height',
    'hoverShadow',
    'padding',
    'rounded',
    'sectionGap',
    'shadow',
    'target',
    'variant',
  ],
  CardContent: [
    'align',
    'align-md',
    'contentPadding',
    'height',
    'stackGap',
    'width',
  ],
  Carousel: [
    'arrowDesign',
    'arrowInset',
    'arrowPosition',
    'arrowReveal',
    'arrowSize',
    'dotDesign',
    'dotPosition',
    'dotSize',
    'dotTone',
    'paging',
    'peek',
    'shadowSpace',
    'slideAlign',
    'slideHeight',
    'unavailableArrow',
  ],
  CarouselItem: ['basis', 'basis-lg', 'basis-md'],
  CategoryHubSection: ['headingVariant'],
  ChartLegend: ['align', 'colorScale', 'verticalAlign'],
  ChatMessage: ['status'],
  CheckboxButton: ['size'],
  CollapsibleInfoPanel: ['defaultSection'],
  ComboChart: [
    'colorScale',
    'curveType',
    'divergingPalette',
    'mode',
    'sequentialPalette',
    'sortBy',
    'tooltipMode',
  ],
  ComparisonBar: ['position'],
  ComparisonTable: ['styleVersion'],
  DataPoint: ['size', 'style'],
  DataTable: ['mode'],
  DegreeCardDetailed: [
    'border',
    'detailListItemsFormat',
    'detailListItemsPosition',
    'footerLayout',
    'readMoreBehavior',
    'tagVariant',
    'target',
  ],
  DegreeCardSimple: ['border', 'readMoreBehavior'],
  DegreeCardTiny: ['border'],
  Drawer: ['direction'],
  EditorialListing: ['readMoreBehavior', 'tagVariant'],
  ExpertBio: ['border', 'headingContext', 'size'],
  ExpertBox: ['variant'],
  ExpertQuote: ['variant'],
  ExpertRow: ['border', 'gap', 'headingContext', 'size'],
  ExportDialog: ['progressIndicator'],
  Flex: [
    'align',
    'align-md',
    'childrenRatio',
    'direction',
    'direction-lg',
    'direction-md',
    'gap',
    'height',
    'justify',
    'overflow',
    'shrink',
    'width',
    'wrap',
  ],
  Footer: ['variant'],
  Form: ['gap'],
  FormField: ['surface'],
  Grid: ['columns-lg', 'columns-md', 'columns-xl', 'gap'],
  GridImage: ['objectFit', 'padding'],
  Heading: ['align', 'color', 'tag', 'variant'],
  HeatmapChart: ['colorScale', 'legendPosition', 'normalization'],
  Hero: ['contentGap', 'variant'],
  Icon: ['background', 'color', 'shape', 'size'],
  Image: [
    'aspect',
    'frame',
    'insetPadding',
    'objectFit',
    'overlayPosition',
    'rounded',
    'roundedSides',
  ],
  ImageCard: [
    'align',
    'fetchPriority',
    'imageAspect',
    'imageBackgroundColor',
    'loading',
    'variant',
  ],
  ImageGrid: ['variant'],
  InfoCard: ['align', 'size', 'variant'],
  Input: [
    'fieldNameWeight',
    'labelColor',
    'placeholderColor',
    'placeholderSize',
    'type',
    'valueSize',
    'variant',
  ],
  InsightCard: ['style'],
  KPIBanner: [
    'playgroundTooltipFormat',
    'playgroundTooltipSide',
    'playgroundTooltipTrigger',
  ],
  Label: ['size', 'variant'],
  LineChart: [
    'colorScale',
    'curveType',
    'divergingPalette',
    'sequentialPalette',
    'tooltipMode',
    'xAxisInterval',
    'xAxisType',
  ],
  LineClamp: ['lines', 'triggerAlign'],
  Link: ['size', 'underline', 'underlineStyle', 'variant', 'weight'],
  List: [
    'arrowDirection',
    'bulletStyle',
    'endRadius',
    'iconGap',
    'iconSize',
    'itemGap',
    'linkColor',
    'markerColor',
    'rowHeight',
    'rowPadding',
    'variant',
    'width',
  ],
  LoadingDots: ['color', 'size'],
  LogoBox: ['shadow', 'size'],
  MediaGallery: [
    'countPlacement',
    'imageFit',
    'slideBasis',
    'slideBasis-lg',
    'slideBasis-md',
  ],
  MediaGalleryViewer: ['background', 'counterVariant', 'counterWeight'],
  Modal: [
    'backdrop',
    'closeButtonVariant',
    'headerPadding',
    'mobilePresentation',
    'padding',
    'panelSide',
    'rounded',
    'shadow',
    'size',
    'surface',
    'variant',
  ],
  MultiSelect: [
    'labelColor',
    'placeholderColor',
    'placeholderSize',
    'rounded',
    'selectedStateTheme',
    'size',
    'tagDisplay',
    'valueSize',
    'variant',
    'width',
  ],
  NavTabs: ['variant'],
  Navbar: [
    'barPaddingX',
    'bottomEdge',
    'collapseBelow',
    'contentWidth',
    'drawerBackColor',
    'drawerClosePlacement',
    'drawerDirection',
    'drawerHeader',
    'drawerHeaderDivider',
    'drawerItemSize',
    'drawerSize',
    'drawerTransition',
    'hoverStyle',
    'linkWeight',
    'logoGap',
    'logoPosition',
    'logoSize',
    'menuColumnGap',
    'menuColumns',
    'menuLabelStyle',
    'menuLabelTop',
    'menuLinkGap',
    'menuLinkHover',
    'menuLinkStyle',
    'menuPaddingBottom',
    'menuPaddingX',
    'menuPaddingY',
    'menuTransition',
    'menuTriggerPlacement',
    'panelOverlay',
    'panelShadow',
    'panelShape',
    'panelWidth',
    'variant',
  ],
  NavbarMenuContent: ['placement'],
  NavigationWrapper: ['target'],
  PageSection: ['alignment', 'variant'],
  Pagination: ['mode'],
  PillButton: [
    'color',
    'hover',
    'padding',
    'rounded',
    'size',
    'variant',
    'weight',
  ],
  Popover: [
    'align',
    'backdrop',
    'collapseBelow',
    'mobilePanelSide',
    'shadow',
    'triggerLabelHiddenBelow',
  ],
  Price: ['size'],
  Progress: [
    'fillTone',
    'labelAlign',
    'labelPosition',
    'labelSize',
    'labelWeight',
    'trackTone',
    'valueWeight',
  ],
  ProgressGroup: ['labelAlign', 'rowGap'],
  Radio: ['appearance', 'controlPosition', 'orientation'],
  RankingCard: ['variant'],
  Rating: [
    'scorePosition',
    'scoreSize',
    'starTone',
    'theme',
    'tooltipSide',
    'variant',
  ],
  ScatterChart: [
    'colorScale',
    'divergingPalette',
    'pointShape',
    'sequentialPalette',
    'tooltipMode',
    'xAxisInterval',
    'xAxisType',
  ],
  ScrollArea: ['dir', 'orientation', 'type'],
  Section: [
    'as',
    'backgroundPosition',
    'backgroundRepeat',
    'backgroundSize',
    'gap',
    'minHeight',
    'padding',
    'position',
    'variant',
  ],
  SectionHeader: ['align', 'align-md', 'color', 'iconColor', 'iconSize'],
  Select: [
    'fieldNameWeight',
    'labelColor',
    'placeholderColor',
    'placeholderSize',
    'rounded',
    'selectedStateTheme',
    'valueSize',
    'variant',
    'width',
  ],
  SelectionTile: ['alignment', 'justify', 'variant'],
  Separator: ['fill', 'orientation', 'radius', 'thickness', 'tone'],
  ShowMore: ['initialState', 'triggerPosition', 'triggerSize', 'triggerWeight'],
  SimpleDataPoint: ['titleVariant', 'valueVariant', 'valueWeight'],
  SliderImage: ['objectFit'],
  SparklineChart: ['lineStyle'],
  Split: ['breakpoint', 'gap', 'ratio'],
  SplitItem: ['spaceAbove'],
  StatColumns: ['dividerTone'],
  StatStyles: ['style', 'valueColor'],
  StickyBar: ['appears', 'screenEdge', 'shadow', 'spaceAbove'],
  StickyColumn: ['headingLevel'],
  StudentLoansBanner: ['layout'],
  StudentLoansInline: ['variant'],
  SubNav: ['layout'],
  TableHead: ['scope'],
  Tabs: [
    'color',
    'gap',
    'listAlign',
    'orientation',
    'panelHeight',
    'unselectedStyle',
    'variant',
  ],
  Text: ['align', 'color', 'lines', 'tag', 'variant', 'weight'],
  Textarea: [
    'labelColor',
    'placeholderColor',
    'placeholderSize',
    'resize',
    'size',
    'valueSize',
    'variant',
  ],
  Timeline: ['color'],
  TimelineEvent: ['color'],
  TimelineEventDescription: ['lineColor', 'lineWidth'],
  TocNav: ['padding'],
  ToggleGroup: ['size', 'type', 'variant'],
  ToggleGroupItem: ['size', 'variant'],
  Tooltip: ['contentFormat', 'side', 'trigger'],
  WaterfallChart: [
    'colorScale',
    'divergingPalette',
    'sequentialPalette',
    'tooltipMode',
  ],
};

export const isUnsetOptionalEnum = (
  prop: { type?: string; required?: boolean } | undefined,
  value: unknown,
): boolean => prop?.type === 'enum' && prop.required !== true && value === '';

export const omitUnsetOptionalEnumProps = (
  props: Record<string, unknown>,
  optionalEnumPropNames: readonly string[] | undefined,
): Record<string, unknown> => {
  if (!optionalEnumPropNames || optionalEnumPropNames.length === 0) {
    return props;
  }
  const names = new Set(optionalEnumPropNames);
  let changed = false;
  const next: Record<string, unknown> = {};
  for (const [key, value] of Object.entries(props)) {
    if (value === '' && names.has(key)) {
      changed = true;
      continue;
    }
    next[key] = value;
  }
  return changed ? next : props;
};
